export default "__VITE_ASSET__BXQMfTXJ__"